import {useMemo} from 'react';

import useUI from './useUI';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

import {EInstanceKey, ERequestClass} from 'coreStore/data/ui/types';

export default () => {
	const requestClasses = useUI('requestClasses');
	const {managerRepository} = useGeneralProvider();

	const instanceKey = useMemo(() => {
		return managerRepository.getUiMgr().getInstanceKey();
	}, [requestClasses]);

	const preferredUniverse = useMemo(() => {
		const universeString = requestClasses.find((r) => r.startsWith('UNIVERSE-'));

		return universeString && universeString.split('-')[1];
	}, [requestClasses]);

	return {
		preferredUniverse,
		isProduction: instanceKey === EInstanceKey.PRODUCTION,
		isStaging: instanceKey === EInstanceKey.STAGING,
		isDevelop: instanceKey === EInstanceKey.DEVELOP,
		isSandbox: instanceKey === EInstanceKey.SANDBOX,
		isLocal: instanceKey === EInstanceKey.LOCAL,
		isCORSRequest: requestClasses.includes(ERequestClass.CORS),
		isRemote: requestClasses.includes(ERequestClass.REMOTE),
		isCmsPreview: requestClasses.includes(ERequestClass.CMS_PREVIEW),
		isLivePreview: requestClasses.includes(ERequestClass.LIVE_PREVIEW),
		instanceKey // TODO: move to useInstanceKey
	};
};
